import Vue from 'vue'
import Router from 'vue-router'
import {trackKV} from '../libs/utils'
// 路由懒加载，当访问相应路径才去加载对应组件
const ArtHoursSnapshot = () => import('@/pages/ArtHoursSnapshot')
const Expert = () => import('@/pages/Expert')
const ExpertRules = () => import('@/pages/ExpertRules')
const XmonsterPlanIndex = () => import('@/pages/XmonsterPlan/Index')
const XmonsterPlanRecords = () => import('@/pages/XmonsterPlan/Records')
const XmonsterPlanRules = () => import('@/pages/XmonsterPlan/Rules')
const SingleEliminationGroupSnapshot = () => import('@/pages/SingleEliminationGroupSnapshot')
const SingleEliminationHelp = () => import('@/pages/SingleEliminationHelp')
const ApplyExpert = () => import('@/pages/ApplyExpert')
const FeedTopic = () => import('@/pages/FeedTopic')
const FeedTopicWithPrice = () => import('@/pages/FeedTopicWithPrice')
const FeedTopicNew = () => import('@/pages/FeedTopicNew')
const FeedTopicCollection = () => import('@/pages/FeedTopicCollection')
const StepDiscountShareSnapshot = () => import('@/pages/StepDiscountShareSnapshot')
const StepDiscountShareCircleSnapshot = () => import('@/pages/StepDiscountShareCircleSnapshot')
const FeedScreenshot = () => import('@/pages/FeedScreenshot')
const FeedSharePicUrl = () => import('@/pages/FeedSharePicUrl')
const MpImport = () => import('@/pages/MpImport')
const DogPassport = () => import('@/pages/DogPassport')
const CollegeMp = () => import('@/pages/CollegeMp')
const NationalDayCampus = () => import('@/pages/NationalDayCampus')
const FeedTinyScreenshot = () => import('@/pages/FeedTinyScreenshot')
const BuzTinyScreenshot = () => import('@/pages/BuzTinyScreenshot')
const PostTinyScreenshot = () => import('@/pages/PostTinyScreenshot')
const PostScreenshot = () => import('@/pages/PostScreenshot')
const GoCardScreenshot = () => import('@/pages/GoCardScreenshot')
const MpDrawActivity = () => import('@/pages/MpDrawActivity')
const DateUserProfileSnapshot = () => import('@/pages/DateUserProfileSnapshot')
const ArtDayBuy = () => import('@/pages/ArtDayBuy')
const DateUserInfoScreenshot = () => import('@/pages/DateUserInfoScreenshot')
const AnnalReport = () => import('@/pages/AnnalReport')
const AnnalReport2019 = () => import('@/pages/AnnalReport2019')
const AnnalReport2019ScreenShot = () => import('@/pages/AnnalReport2019ScreenShot')
const Art24Hours = () => import('@/pages/Art24Hours')
const ShareWeixin = () => import('@/pages/ShareWeixin')
const TalkShowLottery = () => import('@/pages/TalkShow/Lottery')
const TalkShowMallIndex = () => import('@/pages/TalkShow/TalkShowMall/Index')
const TalkShowMallGoodDetail = () => import('@/pages/TalkShow/TalkShowMall/GoodDetail')
const TalkShowMallShoppingCart = () => import('@/pages/TalkShow/TalkShowMall/ShoppingCart')
const TalkShowMallPay = () => import('@/pages/TalkShow/TalkShowMall/Pay')
const TalkShowMallOrderDetail = () => import('@/pages/TalkShow/TalkShowMall/OrderDetail')
const TalkShowMallMyOrders = () => import('@/pages/TalkShow/TalkShowMall/MyOrders')
const TalkShowMallChooseAddress = () => import('@/pages/TalkShow/TalkShowMall/ChooseAddress')
const MainFeed = () => import('@/pages/TalkShow/MainFeed')
const TalkShowShare = () => import('@/pages/TalkShow/TalkShowShare')
const AddAddress = () => import('@/pages/AddAddress')
const TalkShowBranch = () => import('@/pages/TalkShow/Branch')
const WeixinActivity = () => import('@/pages/WeixinActivity')
const FeedListHome = () => import('@/pages/Feed/ListHome')
const FeedInfo = () => import('@/pages/Feed/Info')
const FeedShai = () => import('@/pages/Feed/Shai')
const SceneRecommend = () => import('@/pages/Feed/SceneRecommend')
const AnswerQuestion = () => import('@/pages/Feed/AnswerQuestion')
const ParentChild = () => import('@/pages/ParentChild/index')
const FeedTrackScreenshot = () => import('@/pages/FeedTrackScreenshot')
const GoLifeExpressAddressList = () => import('@/pages/GoLife/ExpressAddressList')
const AddExpressAddress = () => import('@/pages/GoLife/AddExpressAddress')
const AddUserInfo = () => import('@/pages/AddUserInfo')
const UserInfoList = () => import('@/pages/UserInfoList')
const GoLifeOrderDetail = () => import('@/pages/GoLife/OrderDetail')
const GoLifeGoodsDetail = () => import('@/pages/GoLife/GoodsDetail')
const GoLifeMakeOrder = () => import('@/pages/GoLife/MakeOrder')
const GoLifeMainPage = () => import('@/pages/GoLife/MainPage')
const GoLifeSuccessBuy = () => import('@/pages/GoLife/SuccessBuy')
const GoLifeAppointment = () => import('@/pages/GoLife/Appointment')
const GoLifePrizeDraw = () => import('@/pages/GoLife/PrizeDraw')
const GoCardMainPage = () => import('@/pages/GoCard/MainPage')
const GoCardDay = () => import('@/pages/GoCard/GoCardDay')
const GoCardDayWelfare = () => import('@/pages/GoCard/GoCardDayWelfare')
const GoCardInviteFriends = () => import('@/pages/GoCard/InviteFriends')
const GoCardNewInviteFriends = () => import('@/pages/GoCard/NewInviteFriends')
const GoCardBecomeVipGift = () => import('@/pages/GoCard/BecomeVipGift')
const PrivilegeIntroduction = () => import('@/pages/GoCard/PrivilegeIntroduction')
const GoLifeOrderList = () => import('@/pages/GoLife/OrderList')
const GoLifeSharePicUrl = () => import('@/pages/GoLife/SharePicUrl')
const DistributorShare = () => import('@/pages/GoLife/DistributorShare')
const DistributorShareV2 = () => import('@/pages/GoLife/DistributorShareV2')
const GoLifeWithdrawList = () => import('@/pages/GoLife/WithdrawList')
const GoLifeMyBonus = () => import('@/pages/GoLife/MyBonus')
const GoLifeApplyAgencyPage = () => import('@/pages/GoLife/ApplyAgencyPage')
const GoLifeMyCouponList = () => import('@/pages/GoLife/MyCouponList')
const GoLifeLottery = () => import('@/pages/GoLife/Lottery')
const GoLifeBindMobile = () => import('@/pages/GoLife/BindMobile')
const SuccessApplyAgencyPage = () => import('@/pages/GoLife/SuccessApplyAgencyPage')
const ReturnCashIntroduction = () => import('@/pages/GoLife/ReturnCashIntroduction')
const ImageUrlShareInMp = () => import('@/pages/GoLife/ImageUrlShareInMp')
const NewImageUrlShareInMp = () => import('@/pages/GoLife/NewImageUrlShareInMp')
const GoCardRenewalCard = () => import('@/pages/GoCard/RenewalCard')
const GoCardFree = () => import('@/pages/GoCard/Free')
const GoCardAppointmentFree = () => import('@/pages/GoCard/AppointmentFree')
const OneMonthFree = () => import('@/pages/GoCard/OneMonthFree')
const TotalOrdersList = () => import('@/pages/TotalOrdersList')
const GoCardFreeGet = () => import('@/pages/WestBundExpo/GoCardFreeGet')
const QRCodeBusinessCard = () => import('@/pages/WestBundExpo/QRCodeBusinessCard')

const JoinWXTroop = () => import('@/pages/WestBundExpo/JoinWXTroop')
const MobileLogin = () => import('@/pages/MobileLogin')
const LetsgoTerm = () => import('@/pages/LetsgoTerm')

const GiftCardInfo = () => import('@/pages/GiftCard/Info')
const EvaluationCouponsIntroduction = () => import('@/pages/GoLife/EvaluationCouponsIntroduction')
const TeamlabIndex = () => import('@/pages/Teamlab/Index')
const GroupCards = () => import('@/pages/GroupCards')
const OrderTickets = () => import('@/pages/Order/Tickets')
const OrderSeatTicketsPay = () => import('@/pages/Order/SeatTicketsPay')
const OrderSeatTickets = () => import('@/pages/Order/SeatTickets')
const OrderCtripTicketNotice = () => import('@/pages/Order/CtripTicketNotice')
const OrderCtripTicketList = () => import('@/pages/Order/CtripTicketList')
const OrderCtripTicket = () => import('@/pages/Order/CtripTicket')

const ShopAppointmentMain = () => import('@/pages/ShopAppointment/Main')
const AppointmentDetail = () => import('@/pages/ShopAppointment/AppointmentDetail')
const DessertCarnivalReservation = () => import('@/pages/DessertCarnivalReservation/Main')
const DessertCarnivalReservationDetail = () => import('@/pages/DessertCarnivalReservation/Detail')
const JayChouExhibitionReservation = () => import('@/pages/JayChouExhibitionReservation/Main')
const JayChouExhibitionReservationDetail = () => import('@/pages/JayChouExhibitionReservation/Detail')

const SmsCampaign = () => import('@/pages/Campaign/sms_campaign')

const Complaint = () => import('@/pages/Complaint')
const ComplaintSuccess = () => import('@/pages/ComplaintSuccess')

const BookExpHome = () => import('@/pages/Campaign/BookExp/home')
const BookExpUpload = () => import('@/pages/Campaign/BookExp/upload')
const BookExpDetail = () => import('@/pages/Campaign/BookExp/book_detail')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/renewal_card',
      name: 'RenewalCard',
      component: GoCardRenewalCard
    },
    {
      path: '/art_screenshot',
      name: 'ArtHoursSnapshot',
      component: ArtHoursSnapshot
    },
    {
      path: '/expert',
      name: 'Expert',
      component: Expert
    },
    {
      path: '/expert_rules',
      name: 'ExpertRules',
      component: ExpertRules
    },
    {
      path: '/xmonster_plan',
      name: 'XmonsterPlanIndex',
      component: XmonsterPlanIndex
    },
    {
      path: '/xmonster_plan/records',
      name: 'XmonsterPlanRecords',
      component: XmonsterPlanRecords
    },
    {
      path: '/xmonster_plan/rules',
      name: 'XmonsterPlanRules',
      component: XmonsterPlanRules
    },
    {
      path: '/group_share',
      name: 'SingleEliminationGroupSnapshot',
      component: SingleEliminationGroupSnapshot
    },
    {
      path: '/single_help',
      name: 'SingleEliminationHelp',
      component: SingleEliminationHelp
    },
    {
      path: '/apply_expert',
      name: 'ApplyExpert',
      component: ApplyExpert
    },
    {
      path: '/feed_topic',
      name: 'FeedTopic',
      component: FeedTopic
    },
    {
      path: '/feed_topic_with_price',
      name: 'FeedTopicWithPrice',
      component: FeedTopicWithPrice
    },
    {
      path: '/feed_topic_new',
      name: 'FeedTopicNew',
      component: FeedTopicNew
    },
    {
      path: '/feed_topic_collection',
      name: 'FeedTopicCollection',
      component: FeedTopicCollection
    },
    {
      path: '/step_share',
      name: 'StepDiscountShareSnapshot',
      component: StepDiscountShareSnapshot
    },
    {
      path: '/step_circle_share',
      name: 'StepDiscountShareCircleSnapshot',
      component: StepDiscountShareCircleSnapshot
    },
    {
      path: '/feed_screenshot_1',
      name: 'FeedScreenshot',
      component: FeedScreenshot
    },
    {
      path: '/feed_screenshot',
      name: 'FeedSharePicUrl',
      component: FeedSharePicUrl
    },
    {
      path: '/mp_import',
      name: 'MpImport',
      component: MpImport
    },
    {
      path: '/dog_passport',
      name: 'DogPassport',
      component: DogPassport
    },
    {
      path: '/college_mp',
      name: 'CollegeMp',
      component: CollegeMp
    },
    {
      path: '/national_day_campus',
      name: 'NationalDayCampus',
      component: NationalDayCampus
    },
    {
      path: '/feed_tiny_screenshot',
      name: 'FeedTinyScreenshot',
      component: FeedTinyScreenshot
    },
    {
      path: '/buz_tiny_screenshot',
      name: 'BuzTinyScreenshot',
      component: BuzTinyScreenshot
    },
    {
      path: '/post_tiny_screenshot',
      name: 'PostTinyScreenshot',
      component: PostTinyScreenshot
    },
    {
      path: '/post_screenshot',
      name: 'PostScreenshot',
      component: PostScreenshot
    },
    {
      path: '/go_card_screenshot',
      name: 'GoCardScreenshot',
      component: GoCardScreenshot
    },
    {
      path: '/mp_draw_activity',
      name: 'MpDrawActivity',
      component: MpDrawActivity
    },
    {
      path: '/date_user_profile_snapshot',
      name: 'DateUserProfileSnapshot',
      component: DateUserProfileSnapshot
    },
    {
      path: '/art_day_buy',
      name: 'ArtDayBuy',
      component: ArtDayBuy
    },
    {
      path: '/date_user_info_screenshot',
      name: 'DateUserInfoScreenshot',
      component: DateUserInfoScreenshot
    },
    {
      path: '/annal_report',
      name: 'AnnalReport',
      component: AnnalReport
    },
    {
      path: '/annal_report_2019',
      name: 'AnnalReport2019',
      component: AnnalReport2019
    },
    {
      path: '/annal_report_2019_screenshot',
      name: 'AnnalReport2019ScreenShot',
      component: AnnalReport2019ScreenShot
    },
    {
      path: '/art_24_hours',
      name: 'Art24Hours',
      component: Art24Hours
    },
    {
      path: '/share_weixin',
      name: 'ShareWeixin',
      component: ShareWeixin
    },
    {
      path: '/talk_show/lottery',
      name: 'TalkShowLottery',
      component: TalkShowLottery
    },
    {
      path: '/talk_show/talk_show_mall',
      name: 'TalkShowMallIndex',
      component: TalkShowMallIndex
    },
    {
      path: '/talk_show/talk_show_mall/good_detail',
      name: 'TalkShowMallGoodDetail',
      component: TalkShowMallGoodDetail
    },
    {
      path: '/talk_show/talk_show_mall/shopping_cart',
      name: 'TalkShowMallShoppingCart',
      component: TalkShowMallShoppingCart
    },
    {
      path: '/talk_show/talk_show_mall/pay',
      name: 'TalkShowMallPay',
      component: TalkShowMallPay
    },
    {
      path: '/talk_show/talk_show_mall/order_detail',
      name: 'TalkShowMallOrderDetail',
      component: TalkShowMallOrderDetail
    },
    {
      path: '/talk_show/talk_show_mall/my_orders',
      name: 'TalkShowMallMyOrders',
      component: TalkShowMallMyOrders
    },
    {
      path: '/talk_show/talk_show_mall/choose_address',
      name: 'TalkShowMallChooseAddress',
      component: TalkShowMallChooseAddress
    },
    {
      path: '/talk_show/main_feed',
      name: 'MainFeed',
      component: MainFeed
      // meta: {
      //   keepAlive: false
      // }
    },
    {
      path: '/talk_show/talk_show_share',
      name: 'TalkShowShare',
      component: TalkShowShare
    },
    {
      path: '/add_address',
      name: 'AddAddress',
      component: AddAddress
    },
    {
      path: '/talk_show/branch',
      name: 'TalkShowBranch',
      component: TalkShowBranch
      // meta: {
      //   keepAlive: false
      // }
    },
    {
      path: '/weixin_activity',
      name: 'WeixinActivity',
      component: WeixinActivity
    },
    {
      path: '/feed/list_home',
      name: 'FeedListHome',
      component: FeedListHome
    },
    {
      path: '/feed/info',
      name: 'FeedInfo',
      component: FeedInfo
    },
    {
      path: '/feed/shai',
      name: 'FeedShai',
      component: FeedShai
    },
    {
      path: '/feed/scene_recommend',
      name: 'SceneRecommend',
      component: SceneRecommend
    },
    {
      path: '/feed/answer_question',
      name: 'AnswerQuestion',
      component: AnswerQuestion
    },
    {
      path: '/parent_child',
      name: 'ParentChild',
      component: ParentChild,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/feed_track_screenshot',
      name: 'FeedTrackScreenshot',
      component: FeedTrackScreenshot
    },
    {
      path: '/go_life/express_address_list',
      name: 'GoLifeExpressAddressList',
      component: GoLifeExpressAddressList
    },
    {
      path: '/go_life/order_detail',
      name: 'GoLifeOrderDetail',
      component: GoLifeOrderDetail
    },
    {
      path: '/go_life/add_express_address',
      name: 'AddExpressAddress',
      component: AddExpressAddress
    },
    {
      path: '/go_life/goods_detail',
      name: 'GoLifeGoodsDetail',
      component: GoLifeGoodsDetail
    },
    {
      path: '/go_life/make_order',
      name: 'GoLifeMakeOrder',
      component: GoLifeMakeOrder
    },
    {
      path: '/go_life/main_page',
      name: 'GoLifeMainPage',
      component: GoLifeMainPage,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/go_life/success_buy',
      name: 'GoLifeSuccessBuy',
      component: GoLifeSuccessBuy
    },
    {
      path: '/go_life/appointment',
      name: 'GoLifeAppointment',
      component: GoLifeAppointment
    },
    {
      path: '/go_life/prize_draw',
      name: 'GoLifePrizeDraw',
      component: GoLifePrizeDraw
    },
    {
      path: '/go_card/main_page',
      name: 'GoCardMainPage',
      component: GoCardMainPage
    },
    {
      path: '/go_card/go_card_day',
      name: 'GoCardDay',
      component: GoCardDay
    },
    {
      path: '/go_card/day_welfare',
      name: 'GoCardDayWelfare',
      component: GoCardDayWelfare
    },
    {
      path: '/go_card/privilege_introduction',
      name: 'PrivilegeIntroduction',
      component: PrivilegeIntroduction
    },
    {
      path: '/go_card/invite_friends',
      name: 'GoCardInviteFriends',
      component: GoCardInviteFriends
    },
    {
      path: '/go_card/new_invite_friends',
      name: 'GoCardNewInviteFriends',
      component: GoCardNewInviteFriends
    },
    {
      path: '/go_card/become_vip_gift',
      name: 'GoCardBecomeVipGift',
      component: GoCardBecomeVipGift
    },
    {
      path: '/go_life/order_list',
      name: 'GoLifeOrderList',
      component: GoLifeOrderList,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/go_life/withdraw_list',
      name: 'GoLifeWithdrawList',
      component: GoLifeWithdrawList
    },
    {
      path: '/go_life/my_bonus',
      name: 'GoLifeMyBonus',
      component: GoLifeMyBonus
    },
    {
      path: '/go_life/apply_agency_page',
      name: 'GoLifeApplyAgencyPage',
      component: GoLifeApplyAgencyPage
    },
    {
      path: '/go_life/share_pic_url1',
      name: 'GoLifeSharePicUrl',
      component: GoLifeSharePicUrl
    },
    {
      path: '/go_life/share_pic_url',
      name: 'DistributorShare',
      component: DistributorShare
    },
    {
      path: '/go_life/share_pic_url_v2',
      name: 'DistributorShareV2',
      component: DistributorShareV2
    },
    {
      path: '/go_life/image_url_share_in_mp_bak',
      name: 'ImageUrlShareInMp',
      component: ImageUrlShareInMp
    },
    {
      path: '/go_life/image_url_share_in_mp',
      name: 'NewImageUrlShareInMp',
      component: NewImageUrlShareInMp
    },
    {
      path: '/go_life/my_coupon_list',
      name: 'GoLifeMyCouponList',
      component: GoLifeMyCouponList
    },
    {
      path: '/go_life/lottery',
      name: 'GoLifeLottery',
      component: GoLifeLottery
    },
    {
      path: '/go_life/bind_mobile',
      name: 'GoLifeBindMobile',
      component: GoLifeBindMobile
    },
    {
      path: '/go_life/evaluation_coupons_introduction',
      name: 'EvaluationCouponsIntroduction',
      component: EvaluationCouponsIntroduction
    },
    {
      path: '/go_life/success_apply_agency_page',
      name: 'SuccessApplyAgencyPage',
      component: SuccessApplyAgencyPage
    },
    {
      path: '/go_life/return_cash_introduction',
      name: 'ReturnCashIntroduction',
      component: ReturnCashIntroduction
    },
    {
      path: '/total_orders_list',
      name: 'TotalOrdersList',
      component: TotalOrdersList
    },
    {
      path: '/west_bund_expo/go_card_free_get',
      name: 'GoCardFreeGet',
      component: GoCardFreeGet
    },
    {
      path: '/west_bund_expo/qr_code_business_card',
      name: 'QRCodeBusinessCard',
      component: QRCodeBusinessCard
    },
    {
      path: '/west_bund_expo/join_wx_troop',
      name: 'JoinWXTroop',
      component: JoinWXTroop
    },
    {
      path: '/supplier/tickets',
      name: 'OrderTickets',
      component: OrderTickets,
      meta: {
        title: '购票',
        keepAlive: false
      }
    },
    {
      path: '/supplier/seat_tickets',
      name: 'OrderSeatTickets',
      component: OrderSeatTickets
    },
    {
      path: '/order/seat_tickets_pay',
      name: 'OrderSeatTicketsPay',
      component: OrderSeatTicketsPay
    },
    {
      path: '/supplier/ctrip_ticket_notice',
      name: 'OrderCtripTicketNotice',
      component: OrderCtripTicketNotice
    },
    {
      path: '/supplier/ctrip_ticket_list',
      name: 'OrderCtripTicketList',
      component: OrderCtripTicketList
    },
    {
      path: '/supplier/ctrip_ticket',
      name: 'OrderCtripTicket',
      component: OrderCtripTicket
    },
    {
      path: '/login/mobile',
      name: 'MobileLogin',
      component: MobileLogin
    },
    {
      path: '/gift_card/info',
      name: 'GiftCardInfo',
      component: GiftCardInfo
    },
    {
      path: '/teamlab/index',
      name: 'TeamlabIndex',
      component: TeamlabIndex
    },
    {
      path: '/go_card/free',
      name: 'GoCardFree',
      component: GoCardFree
    },
    {
      path: '/go_card/appointment_free',
      name: 'GoCardAppointmentFree',
      component: GoCardAppointmentFree
    },
    {
      path: '/go_card/one_month_free',
      name: 'OneMonthFree',
      component: OneMonthFree
    },
    {
      path: '/group_cards',
      name: 'GroupCards',
      component: GroupCards
    },
    {
      path: '/letsgo_term',
      name: 'LetsgoTerm',
      component: LetsgoTerm
    },
    {
      path: '/add_user_info',
      name: 'AddUserInfo',
      component: AddUserInfo
    },
    {
      path: '/user_info_list',
      name: 'UserInfoList',
      component: UserInfoList,
      meta: {
        title: '新增实名观演人'
      }
    },
    {
      path: '/shop_appointment/main',
      name: 'ShopAppointmentMain',
      component: ShopAppointmentMain
    },
    {
      path: '/shop_appointment/appointment_detail',
      name: 'AppointmentDetail',
      component: AppointmentDetail
    },
    {
      path: '/dessert_carnival_reservation',
      name: 'DessertCarnivalReservation',
      component: DessertCarnivalReservation
    },
    {
      path: '/dessert_carnival_reservation/detail',
      name: 'DessertCarnivalReservationDetail',
      component: DessertCarnivalReservationDetail
    },
    {
      path: '/jaychou_reservation',
      name: 'JayChouExhibitionReservation',
      component: JayChouExhibitionReservation
    },
    {
      path: '/jaychou_reservation/detail',
      name: 'JayChouExhibitionReservationDetail',
      component: JayChouExhibitionReservationDetail
    },
    {
      path: '/campaign/sms_campaign',
      name: 'SmsCampaign',
      component: SmsCampaign
    },
    {
      path: '/complaint',
      name: 'Complaint',
      component: Complaint
    },
    {
      path: '/complaint_success',
      name: 'ComplaintSuccess',
      component: ComplaintSuccess
    },
    {
      path: '/campaign/huangpu_shop',
      name: 'HuangPuMiniShop',
      component: () => import('@/pages/Campaign/huangpu_shop/index'),
      meta: {
        title: '2021黄浦区特色小店征集',
        keepAlive: false
      }
    },
    {
      path: '/campaign/huangpu_shop/edit',
      name: 'HuangPuMiniShopEdit',
      component: () => import('@/pages/Campaign/huangpu_shop/edit'),
      meta: {
        title: '2021黄浦区特色小店征集',
        keepAlive: false
      }
    },
    {
      path: '/campaign/huangpu_shop/list',
      name: 'HuangPuMiniShopList',
      component: () => import('@/pages/Campaign/huangpu_shop/list'),
      meta: {
        title: '2021黄浦区特色小店征集',
        keepAlive: false
      }
    },
    {
      path: '/campaign/huangpu_shop/winning_list',
      name: 'HuangPuMiniShopWinningList',
      component: () => import('@/pages/Campaign/huangpu_shop/winning_list'),
      meta: {
        title: '黄浦区特色小店星光地图',
        keepAlive: false
      }
    },
    {
      path: '/campaign/huangpu_shop/shop_map',
      name: 'HuangPuMiniShopMap',
      component: () => import('@/pages/Campaign/huangpu_shop/shop_map'),
      meta: {
        title: '黄浦区特色小店星光地图',
        keepAlive: false
      }
    },
    {
      path: '/campaign/huangpu_shop/total_shop_map',
      name: 'HuangPuMiniTotalShopMap',
      component: () => import('@/pages/Campaign/huangpu_shop/total_shop_map'),
      meta: {
        title: '黄浦区特色小店星光地图'
      }
    },
    {
      path: '/campaign/epidemic_prevention_register',
      name: 'EpidemicPreventionRegister',
      component: () => import('@/pages/Campaign/epidemic_prevention_register/index'),
      meta: {
        title: '走起Go',
        keepAlive: false
      }
    },
    {
      path: '/campaign/epidemic_prevention_register/info',
      name: 'EpidemicPreventionRegisterInfo',
      component: () => import('@/pages/Campaign/epidemic_prevention_register/info'),
      meta: {
        title: '走起Go',
        keepAlive: false
      }
    },
    {
      path: '/campaigns/book_exp/upload',
      name: 'BookExpUpload',
      component: BookExpUpload
    },
    {
      path: '/campaigns/book_exp/home',
      name: 'BookExpHome',
      component: BookExpHome
    },
    {
      path: '/campaigns/book_exp/book_detail',
      name: 'BookExpBookDetail',
      component: BookExpDetail
    },
    {
      path: '/campaign/electric_music_festival',
      name: 'ElectricMusicFestival',
      component: () => import('@/pages/Campaign/electric_music_festival/index')
    },
    {
      path: '/campaign/Lafite',
      name: 'LafiteActivity',
      component: () => import('@/pages/Campaign/lafite/index')
    },
    {
      path: '/qr_code',
      name: 'QrCodePage',
      component: () => import('@/pages/QrCodePage')
    },
    {
      path: '/campaigns/wx_groups_v2',
      name: 'WxGroups',
      component: () => import('@/pages/Campaign/wx_group/index')
    },
    {
      path: '/campaigns/wx_groups_v2',
      name: 'WxGroups',
      component: () => import('@/pages/Campaign/wx_group/index')
    },
    {
      path: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  let trackParam = {
    action: 'view_page',
    path: to.path,
    hash: to.path,
    target: encodeURIComponent(to.fullPath),
    utm_source: to.query.utm_source || 'unknown'
  }
  document.title = (to.meta && to.meta.title) || '走起'
  trackKV(trackParam)
  // if (from.path.indexOf('branch') !== -1 && to.path.indexOf('main_feed') !== -1) {
  //   // console.log('111111')
  //   from.meta.keepAlive = false
  //   to.meta.keepAlive = true
  // }
  // if (from.path.indexOf('parent_child') !== -1) {
  //   from.meta.keepAlive = true
  // }
  if (from.path.indexOf('/go_life/main_page') !== -1) {
    from.meta.keepAlive = true
  } else if (from.path.indexOf('/go_life/order_list') !== -1) {
    from.meta.keepAlive = true
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js